import { CountryCode, OrganizationCountry } from "../enums/country";
import { Locales } from "../enums/locales";
export const canTranslateForms = (country) => {
    return (country === OrganizationCountry.Canada ||
        country === OrganizationCountry.UnitedStates ||
        country === OrganizationCountry.Germany);
};
const ENGLISH_FLAG_BY_COUNTRY = {
    [OrganizationCountry.UnitedStates]: CountryCode.US,
    [OrganizationCountry.Australia]: CountryCode.AU,
    [OrganizationCountry.NewZealand]: CountryCode.NZ,
    [OrganizationCountry.Ireland]: CountryCode.IE,
};
const FLAG_BY_LOCALE = {
    [Locales.EN]: CountryCode.GB,
    [Locales.FR]: CountryCode.FR,
    [Locales.ES]: CountryCode.ES,
    [Locales.DE]: CountryCode.DE,
};
export const getLocaleFlagCountryCode = (locale, organizationCountry) => {
    if (locale === Locales.EN && organizationCountry) {
        return ENGLISH_FLAG_BY_COUNTRY[organizationCountry] ?? FLAG_BY_LOCALE[Locales.EN];
    }
    return FLAG_BY_LOCALE[locale];
};
export const getOppositeLocale = ({ organizationCountry, locale }) => {
    if (!organizationCountry || !locale) {
        return Locales.EN;
    }
    if (organizationCountry === OrganizationCountry.UnitedStates) {
        return locale === Locales.EN ? Locales.ES : Locales.EN;
    }
    if (organizationCountry === OrganizationCountry.Germany) {
        return locale === Locales.DE ? Locales.EN : Locales.DE;
    }
    if (organizationCountry === OrganizationCountry.GreatBritain) {
        return locale === Locales.FR ? Locales.EN : Locales.FR;
    }
    return locale === Locales.FR ? Locales.EN : Locales.FR;
};
